import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({
    id: '',
    imoNumber: '',
    regsDate: '',
    portOfRegistry: '',
    officialNumber: '',
    arrivalDate: '',
    commencementDate: '',
    departureDate: '',
    rate: '',
    quantity: '',
    total: '',
    finalAmount: '',
    paymentMode: '',
    paymentStatus: '',

    portTypeId: {
      id: ''
    },
    feeTypeId: {
      id: ''
    },
    commodityId: {
      id: ''
    },
    vesselId: {
      id: ''
    },
    operatorId: {
      id: ''
    },
    subCommodityId: {
      id: ''
    },
    subSubCommodityId: {
      id: ''
    },


    portId: {
      id: ''
    },
    flag: '',
    coastal: '',
    dwt: '',
    grt: '',
    nrt: '',
    transhipment: '',
    penaltyDays: '',
    penaltyTotal: '',

    lastPortCall: '',
    nextPortCall: '',
    completionDate: '',
    supportingDoc: '',
    penaltyAmount: '',

    grandTotal: '',
    tds: '',
    cgst: '',
    sgst: '',
    igst: '',

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: { id: value } });
  };

  //*********************************** Fetch invoice data when the modal opens ********************************************************
  const token = authServices.getToken();
  
  useEffect(() => {

    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');

        try {
          const response = await apiClient.get(`/api/admin/fee_collection/${invoiceId}`,{
        
            headers: {
              'access_token': token,
            }});
          if (response.data.Status === "SUCCESS") {

            setFormData({
              id: invoiceId || '',
              imoNumber: response.data.data.imoNumber || '',
              regsDate: response.data.data.regsDate || '',
              portOfRegistry: response.data.data.portOfRegistry || '',
              officialNumber: response.data.data.officialNumber || '',
              arrivalDate: response.data.data.arrivalDate || '',
              commencementDate: response.data.data.commencementDate || '',
              departureDate: response.data.data.departureDate || '',
              rate: response.data.data.rate || '',
              quantity: response.data.data.quantity || '',
              total: response.data.data.total || '',
              finalAmount: response.data.data.finalAmount || '',
              paymentMode: response.data.data.paymentMode || '',
              paymentStatus: response.data.data.paymentStatus || '',

              portTypeId: { id: response?.data?.data?.portTypeId?.id || '' },
              feeTypeId: { id: response?.data?.data?.feeTypeId?.id || '' },
              commodityId: { id: response?.data?.data?.commodityId?.id || '' },
              vesselId: { id: response?.data?.data?.vesselId?.id || '' },
              operatorId: { id: response?.data?.data?.operatorId?.id || '' },
              subCommodityId: { id: response?.data?.data?.subCommodityId?.id || '' },
              subSubCommodityId: { id: response?.data?.data?.subSubCommodityId?.id || '' },

              portId: { id: response?.data?.data?.portId?.id || '' },
              flag: response.data.data.flag || '',
              coastal: response.data.data.coastal || '',
              dwt: response.data.data.dwt || '',
              grt: response.data.data.grt || '',
              nrt: response.data.data.nrt || '',
              transhipment: response.data.data.transhipment || '',
              penaltyDays: response.data.data.penaltyDays || '',
              penaltyTotal: response.data.data.penaltyTotal || '',
              lastPortCall: response.data.data.lastPortCall || '',
              nextPortCall: response.data.data.nextPortCall || '',
              completionDate: response.data.data.completionDate || '',
              supportingDoc: response.data.data.supportingDoc || '',
              penaltyAmount: response.data.data.penaltyAmount || '',
              grandTotal: response.data.data.grandTotal || '',
              tds: response.data.data.tds || '',
              cgst: response.data.data.cgst || '',
              sgst: response.data.data.sgst || '',
              igst: response.data.data.igst || '',
            });
          }
          else {
            console.log(response.data.message)
          }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };

    fetchInvoiceData();
  }, [invoiceId, edit]);


  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/fee_collection/update`, formData,{
        
        headers: {
          'access_token': token,
        }});

      if (response.data.Status === "SUCCESS") {
        console.log("success", response.data.message)

      }
      else {
        console.log("else", response.data.message)

      }
    }
    catch (error) {
      console.error('catch Error :-', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };


  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Fee_Collection
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="imoNumber" className="label-custom">IMO Number</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="imoNumber"
                        name="imoNumber"
                        value={formData.imoNumber}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="regsDate" className="label-custom">Register Date</label>
                      <input
                        type="date"
                        className="input-custom"
                        id="regsDate"
                        name="regsDate"
                        value={formData.regsDate}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="portOfRegistry" className="label-custom">Port Of Registry</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="portOfRegistry"
                        name="portOfRegistry"
                        value={formData.portOfRegistry}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="officialNumber" className="label-custom">Official Number</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="officialNumber"
                        name="officialNumber"
                        value={formData.officialNumber}
                        onChange={handleChange}
                      />
                    </div>
                    </div>
                    
                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="arrivalDate" className="label-custom">Arrival Date</label>
                      <input
                        type="date"
                        className="input-custom"
                        id="arrivalDate"
                        name="arrivalDate"
                        value={formData.arrivalDate}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="commencementDate" className="label-custom">Commencement Date</label>
                      <input
                        type="date"
                        className="input-custom"
                        id="commencementDate"
                        name="commencementDate"
                        value={formData.commencementDate}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="departureDate" className="label-custom">Departure Date</label>
                      <input
                        type="date"
                        className="input-custom"
                        id="departureDate"
                        name="departureDate"
                        value={formData.departureDate}
                        onChange={handleChange}
                      />
                    </div>
                  
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="rate" className="label-custom">Rate</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="rate"
                        name="rate"
                        value={formData.rate}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="quantity" className="label-custom">Quantity</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="quantity"
                        name="quantity"
                        value={formData.quantity}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="total" className="label-custom">Total</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="total"
                        name="total"
                        value={formData.total}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="finalAmount" className="label-custom">Final Amount</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="finalAmount"
                        name="finalAmount"
                        value={formData.finalAmount}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="paymentMode" className="label-custom">Payment Mode</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="paymentMode"
                        name="paymentMode"
                        value={formData.paymentMode}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="paymentStatus" className="label-custom">Payment Status</label>
                      <select
                        className="input-custom"
                        id="paymentStatus"
                        name="paymentStatus"
                        value={formData.paymentStatus}
                        onChange={handleChange}
                      >
                        <option value="">-- Select --</option>
                        <option value="Success">Success</option>
                        <option value="Pending">Pending</option>
                        <option value="Failed">Failed</option>
                      </select>
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="portTypeId" className="label-custom">Port TypeId</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="portTypeId"
                        name="portTypeId"
                        value={formData.portTypeId.id}
                        onChange={handleChange2}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="feeTypeId" className="label-custom">Fee TypeId</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="feeTypeId"
                        name="feeTypeId"
                        value={formData.feeTypeId.id}
                        onChange={handleChange2}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="commodityId" className="label-custom">Commodity Id</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="commodityId"
                        name="commodityId"
                        value={formData.commodityId.id}
                        onChange={handleChange2}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="vesselId" className="label-custom">Vessel Id</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="vesselId"
                        name="vesselId"
                        value={formData.vesselId.id}
                        onChange={handleChange2}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="operatorId" className="label-custom">Operator Id</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="operatorId"
                        name="operatorId"
                        value={formData.operatorId.id}
                        onChange={handleChange2}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="subCommodityId" className="label-custom">Sub Commodity Id</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="subCommodityId"
                        name="subCommodityId"
                        value={formData.subCommodityId.id}
                        onChange={handleChange2}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="subSubCommodityId" className="label-custom">Sub Sub Commodity Id</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="subSubCommodityId"
                        name="subSubCommodityId"
                        value={formData.subSubCommodityId.id}
                        onChange={handleChange2}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="portId" className="label-custom">PortId</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="portId"
                        name="portId"
                        value={formData.portId.id}
                        onChange={handleChange2}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="flag" className="label-custom">Flag</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="flag"
                        name="flag"
                        value={formData.flag}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="coastal" className="label-custom">Coastal</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="coastal"
                        name="coastal"
                        value={formData.coastal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="dwt" className="label-custom">DWT</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="dwt"
                        name="dwt"
                        value={formData.dwt}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="grt" className="label-custom">GRT</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="grt"
                        name="grt"
                        value={formData.grt}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="nrt" className="label-custom">NRT</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="nrt"
                        name="nrt"
                        value={formData.nrt}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="transhipment" className="label-custom">Transhipment</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="transhipment"
                        name="transhipment"
                        value={formData.transhipment}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="penaltyDays" className="label-custom">Penalty Days</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="penaltyDays"
                        name="penaltyDays"
                        value={formData.penaltyDays}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="penaltyTotal" className="label-custom">Penalty Total</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="penaltyTotal"
                        name="penaltyTotal"
                        value={formData.penaltyTotal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="lastPortCall" className="label-custom">Last PortCall</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="lastPortCall"
                        name="lastPortCall"
                        value={formData.lastPortCall}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="nextPortCall" className="label-custom">Next PortCall</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="nextPortCall"
                        name="nextPortCall"
                        value={formData.nextPortCall}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="completionDate" className="label-custom">Completion Date</label>
                      <input
                        type="date"
                        className="input-custom"
                        id="completionDate"
                        name="completionDate"
                        value={formData.completionDate}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="supportingDoc" className="label-custom">Supporting Doc</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="supportingDoc"
                        name="supportingDoc"
                        value={formData.supportingDoc}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="penaltyAmount" className="label-custom">Penalty Amount</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="penaltyAmount"
                        name="penaltyAmount"
                        value={formData.penaltyAmount}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="grandTotal" className="label-custom">Grand Total</label>
                      <input
                        type="grandTotal"
                        className="input-custom"
                        id="grandTotal"
                        name="grandTotal"
                        value={formData.grandTotal}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="tds" className="label-custom">TDS</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="tds"
                        name="tds"
                        value={formData.tds}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                  <div className='row w-100'>
                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="cgst" className="label-custom">CGST</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="cgst"
                        name="cgst"
                        value={formData.cgst}
                        onChange={handleChange}
                      />
                    </div>

                    <div className=" spacing w-50 d-inline-block">
                      <label htmlFor="sgst" className="label-custom">SGST</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="sgst"
                        name="sgst"
                        value={formData.sgst}
                        onChange={handleChange}
                      />
                    </div>
                    </div>

                    <div className=" spacing d-inline-block"  style={{width:"45.20vw"}}>
                      <label htmlFor="igst" className="label-custom">IGST</label>
                      <input
                        type="text"
                        className="input-custom"
                        id="igst"
                        name="igst"
                        value={formData.igst}
                        onChange={handleChange}
                      />
                    </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
